import React from 'react'

export const Peoples = () => {
  return (
    <div>Peoples building soon.....</div>
  )
}
